import { render, staticRenderFns } from "./webThree.vue?vue&type=template&id=fff0c516&scoped=true&"
import script from "./webThree.vue?vue&type=script&lang=js&"
export * from "./webThree.vue?vue&type=script&lang=js&"
import style0 from "./webThree.vue?vue&type=style&index=0&id=fff0c516&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff0c516",
  null
  
)

export default component.exports